import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['label']

  declare readonly hasLabelTarget: boolean
  declare readonly labelTarget: HTMLDivElement

  input(e: InputEvent): void {
    const target = e.target as HTMLInputElement
    this.labelTarget.textContent = target?.value + '%'
  }
}
